module.exports = __webpack_public_path__ + "img/labor_day_card_mob_deal_v1.32db69e.png";